import LabelLang from "component/LabelLang/label-lang";
// import React from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import ChevronIcon from "svg-icons/chevron-icon";

const IndicatorSearchCard = ({
  id,
  indicators,
  mainSubjectId = null,
  subjectId = null,
}) => {
  const intl = useIntl();
  return (
    <div className="row gx-0 gx-md-3 gy-md-0 gy-2 d-flex align-items-center">
      {/* Scrollable section*/}
      <div
        className="col-12"
        style={{
          maxHeight: "250px", // Adjust as needed
          overflowY: "auto",
        }}
      >
        <div className="row gx-0 gx-md-3 gy-md-0 gy-2 d-flex align-items-center">
          {indicators.map((item, i) => (
            <div key={i} className="col-md-4">
              <div className="links-list">
                <Link
                  to={`/data/mainSubject/${
                    mainSubjectId ?? item.mainSubjectId
                  }/subSubject/${
                    subjectId ?? item.subSubjectId
                  }/data-visualization/${item?.id}`}
                >
                  <ChevronIcon width={20} height={12} color="#1F254B00 " />
                  <span style={{ color: "#1F254B" }}>
                    <LabelLang
                      id="name"
                      defaultValue={item?.name}
                      translations={item?.translations}
                    />
                  </span>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IndicatorSearchCard;
